import {
  common as COMMON_CURRENCIES,
  names as CURRENCY_NAMES,
  preferred as PREFERRED_CURRENCIES,
} from '../../constants'

type Option = {
  value: string
  label: string
}

export const gerCurrencyOptions = () => {
  const preferred: Option[] = PREFERRED_CURRENCIES.map((c: string) => {
    const label = CURRENCY_NAMES[c as keyof typeof CURRENCY_NAMES] as string

    return {
      value: c,
      label,
    }
  })

  const common: Option[] = COMMON_CURRENCIES.map((c: string) => {
    const label = CURRENCY_NAMES[c as keyof typeof CURRENCY_NAMES] as string

    return {
      value: c,
      label,
    }
  })

  return [...preferred, ...common]
}
